<template>
    <ShowTemplate
        @reloadAffiliationPanel="reloadAffiliationPanel"
        :model="user"
        :owners="
            user.employers_without_access_scope.filter(
                (employer) => employer != null
            )
        "
        :ownersTitle="$lang.get('Employed at')"
        :descriptionTabs="descriptionTabs"
        :can="permissions"
        :interactionsDisabled="true"
        :relations="relations"
        :affiliationPanels="affiliationPanels"
    >
        <template #imageSlot>
            <CoverPicture
                modelClass="user"
                :coverPictureId="
                    user.mediaIds.length >= 2 ? user.mediaIds[1] : null
                "
                :detailPictureId="
                    user.mediaIds.length >= 1 ? user.mediaIds[0] : null
                "
            />
        </template>
        <template #tagSlot>
            <PartnerTag v-if="isPartner" />
        </template>
        <template #toolRowSlot v-if="$page.props.auth.user && !isMe">
            <TextTooltip
                v-if="isContact"
                :text="
                    $lang.get(':name is one of your contacts', {
                        name: user.name,
                    })
                "
            >
                <div
                    class="flex cursor-help items-center gap-x-2 border rounded-full border-user-accent text-user-accent p-1 whitespace-nowrap"
                >
                    <PhUserCheck class="size-7" />
                </div>
            </TextTooltip>

            <div
                v-else-if="hasSentContactRequest"
                class="flex items-center gap-x-2 border rounded-full border-user-accent text-user-accent p-3 whitespace-nowrap"
            >
                <PhCheck class="size-6" />
                <p v-text="$lang.get('Request sent')" />
            </div>

            <Link
                v-else
                :href="
                    hasReceivedContactRequest
                        ? route('profile.quickapprove_contact_request', user.id)
                        : route('user.contact.request', user.id)
                "
                method="post"
            >
                <BaseButton
                    size="md"
                    class="flex items-center gap-x-2"
                    colors="bg-user-accent hover:bg-user-accent-hover text-white whitespace-nowrap"
                >
                    <PhUserPlus class="size-8" />
                    <span v-text="$lang.get('Send contact request')" />
                </BaseButton>
            </Link>

            <!-- <BaseButton
                v-else-if="hasRequestedToJoin"
                size="xl"
                class="flex items-center gap-x-1"
                colors="border border-organization-accent text-organization-accent cursor-default"
            >
                <PhCheck class="size-6" />
                <span v-text="$lang.get('Request sent')" />

                <TextTooltip
                    :text="
                        $lang.get(
                            'A membership request has been sent to :definitive_organization. You will be notified when your request is accepted.',
                            {
                                definitive_organization:
                                    this.$getBaseModelTranslation({
                                        modelName: 'organization',
                                        wordClass: 'definitive',
                                    }),
                            }
                        )
                    "
                >
                    <PhQuestion
                        class="size-5 hover:text-organization-accent-hover transition-colors duration-button-hover cursor-help"
                        weight="fill"
                    />
                </TextTooltip>
            </BaseButton> -->
        </template>
    </ShowTemplate>
</template>

<script>
import ShowTemplate from '@/Templates/ShowTemplate.vue'
import CoverPicture from '@/Templates/ShowTemplateComponents/CoverPicture.vue'
import ContactPanel from '@/Components/Panels/AffiliationPanel/ContactPanel.vue'
import MembershipsPanel from '@/Components/Panels/AffiliationPanel/MembershipsPanel.vue'
import { router, Link } from '@inertiajs/vue3'
import { PhUserCheck, PhUserPlus, PhCheck } from '@phosphor-icons/vue'
import BaseButton from '@/Components/Elements/BaseButton.vue'
import TextTooltip from '@/Components/Elements/TextTooltip.vue'
import PartnerTag from '@/Components/Elements/Tags/PartnerTag.vue'

export default {
    components: {
        ShowTemplate,
        CoverPicture,
        ContactPanel,
        MembershipsPanel,
        PhUserPlus,
        PhUserCheck,
        PhCheck,
        BaseButton,
        Link,
        TextTooltip,
        PartnerTag,
    },

    props: {
        user: {
            type: Object,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
        resources: {
            type: Object,
            default: {},
        },
        events: {
            type: Object,
            default: {},
        },
        contacts: {
            type: Array,
            default: [],
        },
        groups: {
            type: Array,
            default: [],
        },
        queryParams: {
            type: Object,
            default: {},
        },
        isMe: {
            type: Boolean,
            required: true,
        },
        isContact: {
            type: Boolean,
            required: true,
        },
        hasSentContactRequest: {
            type: Boolean,
            required: true,
        },
        hasReceivedContactRequest: {
            type: Boolean,
            required: true,
        },
        isPartner: {
            type: Boolean,
            required: true,
        },
    },

    computed: {
        descriptionTabs() {
            return [
                {
                    id: 'description',
                    name: this.$lang.get('Description'),
                    content: this.user.description,
                },
            ].filter((tab) => !!tab.content)
        },

        relations() {
            return [this.resources, this.events].filter(
                (relation) => Object.keys(relation).length > 0
            )
        },

        affiliationPanels() {
            return [
                {
                    id: 'contacts',
                    component: ContactPanel,
                    parentModel: this.user,
                    items: this.contacts,
                },
                {
                    id: 'memberships',
                    component: MembershipsPanel,
                    parentModel: this.user,
                    items: this.groups,
                },
            ]
        },
    },

    methods: {
        reloadAffiliationPanel(id) {
            if (id === 'contacts') {
                router.reload({
                    only: ['contacts'],
                })
            } else if (id === 'memberships') {
                router.reload({
                    only: ['groups'],
                })
            }
        },
    },
}
</script>
